import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import TitleSection from "src/components/TitleSection/TitleSection";
import EventFinished from "src/components/EventFinished";
import useResponsiveImageUrl from "src/utils/useResponsiveImageUrl";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import DynamicGoogleFormSubmitter from "src/components/Form/DynamicGoogleFormSubmitter";
import Button from "src/components/Button/Button";
import TournamentDropDownText from "src/pages/poker/tournaments/TournamentDropDownText";

const FORM_SECTION_ID = "ultimate-dad-form";

const UltimateDad2026 = () => {
  const { t, i18n } = useTranslation();

  const scrollToForm = () => {
    document.getElementById(FORM_SECTION_ID)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <UltimateDadDiv>
      <EventFinished scheduleKeyName="ultimateDad2026" />
      <Hero
        image={`promotions/gaming-machines/the-ultimate-dad-night-2025/ultimate-dad-night-logo-2400x2400px-${i18n.language}.png`}
        bgImage="promotions/gaming-machines/the-ultimate-dad-night-2025/ultimate-dad-night-hero-image-2400x800px.jpg"
        buttonSettings={null}
        darkenBg={0.5}
        descriptionBgColor="#000000"
        className="ultimate-dad-hero"
      >
        <HeroTitleBlock>
          <h1 className="hero-title-line-1">{t("ultimateDad2026.content.title")}</h1>
          <h1 className="hero-title-line-2">{t("ultimateDad2026.content.subTitle")}</h1>
          <span className="hero-title-divider" aria-hidden="true" />
          <p className="hero-description">{t("ultimateDad2026.hero.description")}</p>
        </HeroTitleBlock>
      </Hero>

      <MainContentDiv>
        <GrandPrizeSection>
          <container-div>
            <GrandPrizeLayout>
              <PrizeInfoCard>
                <h2 className="grand-prize-title">{t("ultimateDad2026.content.text")}</h2>
                <p className="grand-prize-subtitle">{t("ultimateDad2026.content.prizeSubtitle")}</p>
                <ul className="prize-features">
                  <li>
                    <ResponsiveImage
                      src="promotions/gaming-machines/the-ultimate-dad-night-2026/wine.png"
                      alt=""
                    />
                    <span>{t("ultimateDad2026.content.prizes.dinner")}</span>
                  </li>
                  <li>
                    <ResponsiveImage
                      src="promotions/gaming-machines/the-ultimate-dad-night-2026/poker.png"
                      alt=""
                    />
                    <div className="prize-feature-text">
                      <span className="prize-feature-main">
                        {t("ultimateDad2026.content.prizes.customGaming")}
                      </span>
                      <ul className="prize-sub-features">
                        <li>{t("ultimateDad2026.content.prizes.poker")}</li>
                        <li>{t("ultimateDad2026.content.prizes.freePlay")}</li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <ResponsiveImage
                      src="promotions/gaming-machines/the-ultimate-dad-night-2026/host.png"
                      alt=""
                    />
                    <span>{t("ultimateDad2026.content.prizes.privateHost")}</span>
                  </li>
                </ul>
                <h3 className="bonus-title">{t("ultimateDad2026.content.extraPrize")}:</h3>
                <p className="bonus-details">
                  <ResponsiveImage
                    src={`promotions/gaming-machines/the-ultimate-dad-night-2026/freeplay.png`}
                    alt=""
                  />
                  <span>{t("ultimateDad2026.content.extraPrizeDetails")}</span>
                </p>
                <div className="enter-now-wrap">
                  <Button
                    label={t("ultimateDad2026.content.enterNow")}
                    onClick={scrollToForm}
                    bgColor="var(--white)"
                    color="#005A9C"
                    hoverBgColor="#005A9C"
                    hoverColor="var(--white)"
                    size="medium"
                  />
                </div>
              </PrizeInfoCard>
              <PrizeImageCol>
                <ResponsiveImage
                  src="promotions/gaming-machines/the-ultimate-dad-night-2026/dads-night-lp-image-side.jpg"
                  alt=""
                />
              </PrizeImageCol>
            </GrandPrizeLayout>
          </container-div>
        </GrandPrizeSection>

        <FormSection id={FORM_SECTION_ID}>
          <FormHeadingBlock>
            <h1 className="form-section-title">{t("ultimateDad2026.content.formHeading")}</h1>
            <span className="form-section-divider" aria-hidden="true" />
          </FormHeadingBlock>
          <Row>
            <Col xs={12} md={12} lg={8} className="mx-auto">
              <DynamicGoogleFormSubmitter
                formId="AKfycbwlBy2ayyODkb4AEtxVsVuGHzYzmjQbzszo0Ze6jaRN_6k97UfbHNDaKkhj-IQhbJ3pGA"
                formTextKey="ultimateDad2026"
                titles={false}
                formFields={[
                  {
                    id: "FirstName",
                    label: "firstName",
                    type: "text",
                    required: true
                  },
                  {
                    id: "LastName",
                    label: "lastName",
                    type: "text",
                    required: true
                  },
                  {
                    id: "Email",
                    label: "email",
                    type: "email",
                    required: true
                  },
                  {
                    id: "PhoneNumber",
                    label: "phoneNumber",
                    type: "text",
                    required: true
                  },
                  {
                    id: "PlayerID",
                    label: "pgPlayerId",
                    type: "text",
                    required: false,
                    placeholder: "pgPlayerIdPlaceholder"
                  },
                  {
                    id: "FatherNominee",
                    label: "fatherNominee",
                    type: "text",
                    required: true
                  }
                ]}
              />
            </Col>
          </Row>
        </FormSection>

        <Row className="mt-4">
          <Col xs={12} md={12} lg={8} className="mx-auto">
            <TermsBox bgImage={useResponsiveImageUrl(
                "promotions/gaming-machines/the-ultimate-dad-night-2025/blue-bricks-2400x725px.jpg"
              )}>
              <div className="inner">
                <TitleSection
                  as={"h3"}
                  dark
                  title={t("ultimateDad2026.content.termsTitle")}
                  borderColor="var(--mutedred)"
                  className="pt-0 pb-0"
                />
                <ReactMarkdown>{t("ultimateDad2026.content.terms")}</ReactMarkdown>
                <TournamentDropDownText
                  dropdownText={{
                    label: t("ultimateDad2026.content.fullTermsLabel"),
                    list: t("ultimateDad2026.content.fullTerms"),
                  }}
                />
              </div>
            </TermsBox>
          </Col>
        </Row>
      </MainContentDiv>
    </UltimateDadDiv>
  );
};

const HeroTitleBlock = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 2.5rem 0;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  letter-spacing: 0.0625rem;
  text-align: center;
  color: var(--white);

  h1.hero-title-line-1,
  h1.hero-title-line-2 {
    margin: 0 auto;
    font-weight: 900;
    font-size: 2.8125rem;
    line-height: 1.2;
    width: 100%;
    max-width: 100%;
    padding: 0 0.5rem;
    text-align: center;
    white-space: normal;
    overflow-wrap: break-word;
    word-wrap: break-word;
  }

  @media screen and (min-width: 992px) {
    h1.hero-title-line-1,
    h1.hero-title-line-2 {
      max-width: 100%;
      padding: 0 1rem;
    }
  }

  h1.hero-title-line-2 {
    margin-top: 0.625rem;
  }

  .hero-title-divider {
    display: block;
    width: 100%;
    max-width: 10rem;
    border-bottom: 0.1875rem solid #8b0000;
    margin: 1rem auto 1.25rem;
  }

  p.hero-description {
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 1.45;
    margin: 0;
    max-width: 50rem;
    padding: 0 1.25rem;
    text-align: center;
  }

  @media screen and (max-width: 991px) {
    padding: 1.25rem 0;

    h1.hero-title-line-1,
    h1.hero-title-line-2 {
      font-size: 2rem;
      padding: 0 1.25rem;
    }

    p.hero-description {
      padding: 0 1.25rem;
    }
  }
`;

const UltimateDadDiv = styled.div`
  width: 100%;
  height: auto;
  background: #000;
  color: var(--white);
  padding-bottom: 1rem;

  .ultimate-dad-hero {
    .hero_text_container {
      background-color: #000;
      backdrop-filter: none;
      padding: 0;
      box-sizing: border-box;
      width: 100%;

      h1.hero-title-line-1,
      h1.hero-title-line-2 {
        font-weight: 900;
        font-size: 2.8125rem;
        line-height: 1.2;
        max-width: 100%;
        width: 100%;
        margin: 0 auto;
        margin-bottom: 0;
        white-space: normal;
        overflow-wrap: break-word;
        word-wrap: break-word;
      }

      h1.hero-title-line-2 {
        margin-top: 0.625rem;
      }

      p.hero-description {
        font-weight: 600;
        font-size: 1.2rem;
        line-height: 1.45;
        max-width: 50rem;
        margin: 0 auto;
        padding: 0 1.25rem;
        text-align: center;
      }

      @media screen and (max-width: 991px) {
        h1.hero-title-line-1,
        h1.hero-title-line-2 {
          font-size: 2rem;
        }
      }
    }

    ${HeroTitleBlock} {
      width: 100%;
    }
  }

  .hero_image {
    padding: 0 2rem;
  }
  .small {
    text-align: center;
  }
  strong {
    color: #CBB695;
  }
  .tournament-drop-down-text {
    margin-bottom: 0;
    button {
      width: 100%;
      max-width: initial;
      height: auto;
      padding: 0.7rem;
      background-color: #111;
      color: var(--mutedwhite);
    }
  }
`;

const PrizeSection = styled.div`
  text-align: center;
  margin: 2rem 0;

  h2 {
    color: #FF5500;
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 1rem;
    text-transform: uppercase;
  }

  p {
    font-size: 1.2rem;
    color: white;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 1.8rem;
    }
    p {
      font-size: 1rem;
    }
  }
`;

const GrandPrizeSection = styled.section`
  padding: 2rem 0;
  margin: 0;
`;

const GrandPrizeLayout = styled.div`
  display: flex;
  gap: 1.25rem;
  align-items: stretch;
  width: 100%;
  max-width: 100%;

  @media (max-width: 991px) {
    flex-direction: column;
  }
`;

const PrizeInfoCard = styled.div`
  flex: 1;
  background-color: #005a9c;
  border-radius: 1.5rem;
  padding: 2rem;
  text-align: left;
  display: flex;
  flex-direction: column;

  .grand-prize-title {
    text-align: center;
    color: #eed09d;
    font-size: 1.75rem;
    font-weight: 700;
    padding: 0.7rem 1.25rem;
    line-height: 1.2;
    border-radius: 1.5rem 1.5rem 0 0;
  }

  .grand-prize-subtitle {
    color: var(--white);
    font-size: 1.125rem;
    font-weight: 700;
    margin: 0 0 1.5rem;
    line-height: 1.4;
  }

  .prize-features {
    list-style: none;
    margin: 0 0 1.5rem;
    padding: 0;

    > li {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      margin-bottom: 1rem;
      color: var(--white);
      font-size: 1rem;
      font-weight: 600;
      line-height: 1.35;

      > img {
        flex-shrink: 0;
        width: 2.5rem;
        height: auto;
        align-self: center;
      }

      > span,
      .prize-feature-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
  }

  .prize-feature-text {
    flex: 1;
  }

  .prize-feature-main {
    display: block;
    margin-bottom: 0.375rem;
  }

  .prize-sub-features {
    list-style: none;
    margin: 0;
    padding: 0 0 0 1rem;

    li {
      position: relative;
      margin-bottom: 0.25rem;
      font-weight: 400;
      font-size: 0.9375rem;
      line-height: 1.4;

      &::before {
        content: "•";
        position: absolute;
        left: -1rem;
      }
    }
  }

  .bonus-title {
    color: var(--white);
    font-size: 1.125rem;
    font-weight: 700;
    margin: 0 0 0.75rem;
  }

  .bonus-details {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    color: var(--white);
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.4;
    margin: 0 0 1.5rem;

    img {
      flex-shrink: 0;
      width: 2.5rem;
      height: auto;
    }

    span {
      flex: 1;
    }
  }

  .enter-now-wrap {
    margin-top: auto;
    display: flex;
    justify-content: center;
    padding-top: 0.5rem;

    button {
      margin: 0;
      font-weight: 700;
    }
  }

  @media (max-width: 768px) {
    padding: 1.5rem;

    .grand-prize-title {
      font-size: 1.5rem;
      margin: -1.5rem -1.5rem 0.75rem;
    }

    .grand-prize-subtitle {
      font-size: 1rem;
    }
  }
`;

const PrizeImageCol = styled.div`
  flex: 1;
  min-width: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 1.5rem;
    display: block;
  }

  @media (max-width: 991px) {
    img {
      min-height: 16rem;
    }
  }
`;

const BonusPrizeSection = styled.div`
  background-color: #111;
  padding: 2rem 1rem;
  text-align: center;

  h3 {
    color: #FF5500;
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 1rem;
    text-transform: uppercase;
  }

  p {
    font-size: 1.2rem;
    color: white;
  }

  @media (max-width: 768px) {
    h3 {
      font-size: 1.5rem;
    }
    p {
      font-size: 1rem;
    }
  }
`;

const FormSection = styled.section`
  margin: 2.5rem 0 2rem;
  padding: 0 1rem;
`;

const FormHeadingBlock = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  letter-spacing: 0.0625rem;
  text-align: center;
  color: var(--white);
  margin-bottom: 1.75rem;

  h1.form-section-title {
    margin: 0 auto;
    font-weight: 900;
    font-size: 2.8125rem;
    line-height: 1.2;
    width: 100%;
    max-width: 50rem;
    padding: 0 1.25rem;
    text-align: center;
    white-space: normal;
    overflow-wrap: break-word;
    word-wrap: break-word;
  }

  .form-section-divider {
    display: block;
    width: 100%;
    max-width: 10rem;
    border-bottom: 0.1875rem solid #8b0000;
    margin: 1rem auto 0;
  }

  @media screen and (max-width: 991px) {
    h1.form-section-title {
      font-size: 2rem;
      padding: 0 1.25rem;
    }
  }
`;

const MainContentDiv = styled.div`
  padding-bottom: 1rem;
  background-color: #000;

  @media (min-width: 768px) {
    padding: 0 1rem 1rem;
  }

  @media (min-width: 992px) {
    padding: 0 0 3rem;
  }

  height: auto;
  width: 100%;

  .row {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
  }
`;

const TermsBox = styled.div`
  padding: 2rem 1rem;
  margin: 2rem 0;
  border-radius: 0.5rem;
  color: var(--white);
  background-image: ${(props) => `url(${props.bgImage})`};
  background-size: cover;
  position: relative;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1;
  }
  .inner {
    position: relative;
    z-index: 2;
    h3 {
      color: var(--white);
    }
    strong {
      color: #CBB695;
    }
    p {
      margin-bottom: 1rem;
    }
    ul {
      margin-top: 1rem;
      margin-bottom: 1rem;
      p {
        margin: 10px 0;
      }
      li {
        white-space: unset;
        list-style: none;
        margin-bottom: 0.5rem;
        &:before {
          content: "•";
          color: #FF5500;
          font-weight: bold;
          display: inline-block;
          width: 1em;
          margin-left: -1em;
        }
      }
    }
  }

`;

export default UltimateDad2026;
